import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../components/SEO';
import Layout from '../layouts/index';
import ReactPlayer from 'react-player';
import HtmlParser from 'html-react-parser';
//import Modal from 'react-bootstrap/Modal';
//import Button from 'react-bootstrap/Button';
//import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import { DemoFormLong } from '../components/DemoFormLongCheckboxes.jsx';

import { DemoFormLongC19 } from '../components/DemoFormLongC19.jsx';

import { navigate } from 'gatsby'

class WistiaPlayer extends React.Component {

    componentDidMount = () => {
        navigate('/covid-support')
        const script = document.createElement("script");
        script.src = "https://fast.wistia.com/embed/medias/j1aatk4i5w.jsonp";
        script.async = true;
        document.body.appendChild(script);

        const script2 = document.createElement("script");
        script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
        script2.async = true;

        document.body.appendChild(script2);
    }


    render() {
        return (
            <div className="wistia_responsive_padding" style={{ padding: "56.25% 0 0 0", margin: "0 0 20px 0", position: "relative", width: "100%" }}>
                <div className="wistia_responsive_wrapper" style={{ height: "100%", left: "0", position: "absolute", top: "0", width: "100%" }}>
                    <div className="wistia_embed wistia_async_j1aatk4i5w videoFoam=true" style={{ height: "100%", position: "relative", width: "100%" }}>
                        <div className="wistia_swatch" style={{ height: "100%", left: "0", opacity: "0", overflow: "hidden", position: "absolute", top: "0", transition: "opacity 200ms", width: "100%" }}>
                            <img src="https://fast.wistia.com/embed/medias/j1aatk4i5w/swatch" style={{ filter: "blur(5px)", height: "100%", width: "100%" }} alt="Example Chart" aria-hidden="true" />
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}


const Home = (props) => {
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;




    return (
        <Layout bodyClass="page-home" ontouchstart>
            <SEO title="Community Support: Free access to ChartHop Scenarios | ChartHop" />
            <Helmet>
                <meta
                    name="description"
                    content="Supporting you through these times. Increase productivity and belonging while decreasing operational burden. Build plans for any and all business scenario."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Community Support: Free access to ChartHop Scenarios | ChartHop" />
                <meta property="og:description" content="Supporting you through these times. Increase productivity and belonging while decreasing operational burden. Build plans for any and all business scenario." />
                <meta property="og:image" content={`https://www.charthop.com/landings/Scenario_RemoveOpenRole.gif`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Supporting you through these times | ChartHop" />
                <meta name="twitter:description" content="Supporting you through these times. Increase productivity and belonging while decreasing operational burden. Build plans for any and all business scenario." />
                <meta name="twitter:image" content={`https://www.charthop.com/landings/Scenario_RemoveOpenRole.gif`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>
            {/* PAGE CONTENT */}

            <section className="intro container sectionSpacing">

                <div className="align-items-center">
                    <h1>React and adapt with ChartHop Scenarios</h1>
                    <p className="pt-1">Supporting you through these times. Increase productivity and belonging while decreasing operational burden. Build plans for any and all business scenario.</p>
                </div>

                <section className="hero-splitSectionSpacing-Video flex-centeredColumn">
                    <div className=" contentBlock">
                        <div className="reactPlayerContainer" >
                            <ReactPlayer
                                url="/landings/Scenario_RemoveOpenRole1.mp4"

                                playing
                                loop
                                muted
                                playsinline
                            />
                        </div>

                        <div>
                            <div className="headerLongForm">
                                <DemoFormLongC19 />
                            </div>
                        </div>
                    </div>
                </section>
            </section>



            <section className="intro container introductionVideoPage">

                <div className="row align-items-center">
                    <h2>As the effects of the spread of COVID-19 continue to unravel, business needs are shifting more quickly than ever before.
                    </h2>
                    <div className="introducing-charthop-video col-12">
                        <p className="pt-1 pb-1"></p>
                        <WistiaPlayer />

                    </div>

                    <div className="introducing-charthop-video col-12">

                        <p className="pt-1 pb-1">
                            We've made ChartHop Scenarios available at no cost during this time.
                        </p>
                        <p>
                            Follow the steps below and you'll be able to design multiple headcount or org scenarios and measure the impact of those changes in no time.
                        </p>
                        <div className="numbered-list">
                            <ol>
                                <p className="mb-0"><li>Request access below</li></p>
                                <p className="mb-0"><li>Gather the data and/or HRIS access for set up</li></p>
                                <p className="mb-0"><li>Schedule 30 min kick-off call</li></p>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={HtmlParser("c19form")} headertext={HtmlParser("<h2 className='stillH1'>Request free access to ChartHop's Scenario Planning tool.</h2>")} />
            </section>
        </Layout>
    );
};


export default Home;


export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;